import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {FormAutofocusDirective} from '../../shared/directives/form-autofocus.directive';

@Component({
  hostDirectives: [FormAutofocusDirective],
  standalone: false,
  selector: 'app-email-body-update-popup',
  templateUrl: './email-body-update-popup.component.html',
  styleUrls: ['./email-body-update-popup.component.css','../../app.component.css']
})
export class EmailBodyUpdatePopupComponent implements OnInit {

  @Input() emailModel!: any;
  bodyForm!: UntypedFormGroup;
  submitted: boolean = false;
  isLoading: boolean = false;
  config = {
    placeholder: '',
    tabsize: 2,
    height: '300px',
    dialogsInBody: 'true',
    toolbar: [
      ['misc', ['codeview', 'undo', 'redo']],
      ['fontsize', ['fontsize',]],
      ['style', ['bold', 'italic', 'underline']],
      ['para', ['paragraph',]],
      ['insert', [ 'link',]]
    ],
  }
  emailBodyContainer = '';

  constructor(
    public fb: UntypedFormBuilder,
    public activeModel: NgbActiveModal
  ) { }

  ngOnInit(): void {
    this.initForm();
    if (this.emailModel) {
      if(this.emailModel.key !== '' && this.emailModel.key == 'trade-user-carrier-added') {
        this.emailBodyContainer = 'custom-email-body'
      }
      this.bodyForm.patchValue({
        body: this.emailModel?.body
      })
    }
  }

  get f() {
    return this.bodyForm.controls;
  }

  initForm() {
    this.bodyForm = this.fb.group({
      body: new UntypedFormControl('', [Validators.required])
    })
  }

  cancel() {
    this.activeModel.close(false)
  }

  onSubmit() {
    this.submitted = true;
    const getDescription = this.bodyForm.controls.body.value;
    if (getDescription == '<p><br></p>' || getDescription == '<br>') {
      this.bodyForm.controls.body.setErrors({ apiError: "Please enter Valid content" })
    }
    if (this.bodyForm.invalid) {
      return false;
    } else {
      this.activeModel.close({ body: this.bodyForm.value.body })
    }
  }

}
